import { Route } from 'vue-router';
import { PermissionsExportsFeatures } from '@/constants/permissions';

export const onHandRouteOption = (name: string, path: string = 'on-hand/view/:id') => ({
  name,
  path,
  meta: {
    disableWarehouseSwitch: true,
    pageTitle: 'On Hand',
    dynamicTitle: true,
    breadcrumb: {
      label: 'On Hand',
      routeName: name,
    },
  },
  props: (route: Route) => ({
    id: route.params.id,
  }),
  component: () => import('@/views/exports/on-hand/OnHandView.vue'),
});
export const exportsRoutes = [
  {
    path: 'export',
    component: () => import('@/layouts/EmptyRouterView.vue'),
    children: [
      {
        path: 'on-hand',
        component: () => import('@/layouts/EmptyRouterView.vue'),
        children: [
          {
            name: 'OnHand',
            path: '',
            meta: {
              pageTitle: 'On Hand List',
              permission: PermissionsExportsFeatures.ON_HAND,
            },
            component: () => import('@/views/exports/on-hand/OnHandList.vue'),
          },
          {
            meta: {
              breadcrumb: {
                label: 'On Hand List',
                routeName: 'OnHand',
              },
              permission: PermissionsExportsFeatures.ON_HAND,
            },
            path: '',
            component: () => import('@/components/exports/on-hand/OnHandBreadcrumbLayout.vue'),
            children: [
              {
                name: 'OnHandView',
                meta: {
                  disableWarehouseSwitch: true,
                  dynamicTitle: true,
                  pageTitle: 'On Hand',
                  permission: PermissionsExportsFeatures.ON_HAND,
                  breadcrumb: {
                    label: 'On Hand',
                    routeName: 'OnHandView',
                  },
                },
                path: 'view/:id',
                props: (route: Route) => ({
                  id: route.params.id,
                }),
                component: () => import('@/views/exports/on-hand/OnHandView.vue'),
              },
              {
                name: 'OnHandCreate',
                meta: {
                  pageTitle: 'On Hand Create',
                  permission: PermissionsExportsFeatures.ON_HAND,
                  breadcrumb: {
                    label: 'Create On Hand',
                    routeName: 'OnHandCreate',
                  },
                },
                path: 'create',
                component: () => import('@/views/exports/on-hand/OnHandCreateView.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'load-plan',
        component: () => import('@/layouts/EmptyRouterView.vue'),
        children: [
          {
            name: 'LoadPlan',
            meta: {
              permission: PermissionsExportsFeatures.LOAD_PLAN,
              pageTitle: 'Load Plan List',
            },
            path: '',
            component: () => import('@/views/exports/load-plan/LoadPlanList.vue'),
          },
          {
            meta: {
              permission: PermissionsExportsFeatures.LOAD_PLAN,
              breadcrumb: {
                label: 'Load Plan List',
                routeName: 'LoadPlan',
                query: (query: Record<string, string>) => ({
                  loadPlanId: query.loadPlanId,
                }),
              },
            },
            path: '',
            component: () => import('@/components/exports/load-plan/LoadPlanBreadcrumbLayout.vue'),
            children: [
              onHandRouteOption('LoadPlanListOnHand'),
              {
                meta: {
                  disableWarehouseSwitch: true,
                  pageTitle: 'Load Plan',
                  permission: PermissionsExportsFeatures.LOAD_PLAN,
                  breadcrumb: {
                    label: (params: Record<string, string>) => `Load Plan ${params.loadPlanNumber}`,
                    routeName: 'LoadPlanView',
                  },
                },
                path: 'view/:loadPlanNumber',
                component: () => import('@/layouts/EmptyRouterView.vue'),
                children: [
                  {
                    path: '',
                    meta: {
                      dynamicTitle: true,
                      pageTitle: 'Load Plan',
                      permission: PermissionsExportsFeatures.LOAD_PLAN,
                    },
                    name: 'LoadPlanView',
                    props: true,
                    component: () => import('@/views/exports/load-plan/LoadPlanView.vue'),
                  },
                  onHandRouteOption('LoadPlanViewOnHand'),
                ],
              },
              {
                name: 'LoadPlanCreate',
                meta: {
                  pageTitle: 'Create Load Plan',
                  permission: PermissionsExportsFeatures.LOAD_PLAN,
                  breadcrumb: {
                    exact: false,
                    label: 'Create Load Plan',
                    routeName: 'LoadPlanCreate',
                  },
                },
                path: 'create',
                component: () => import('@/views/exports/load-plan/LoadPlanCreateView.vue'),
              },
              {
                meta: {
                  pageTitle: 'Load Guide List',
                  permission: PermissionsExportsFeatures.LOAD_GUIDE,
                  breadcrumb: {
                    label: 'Load Guides',
                    routeName: 'LoadGuides',
                    query: (query: Record<string, string>) => ({
                      loadGuideId: query.loadGuideId,
                    }),
                  },
                },
                path: 'load-guides',
                component: () => import('@/layouts/EmptyRouterView.vue'),
                children: [
                  {
                    meta: {
                      pageTitle: 'Load Guide List',
                      permission: PermissionsExportsFeatures.LOAD_GUIDE,
                    },
                    path: '',
                    name: 'LoadGuides',
                    props: true,
                    component: () => import('@/views/exports/load-guide/LoadGuideScheduleView.vue'),
                  },
                  onHandRouteOption('LoadGuideOnHand'),
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'barcode-scanning',
        component: () => import('@/layouts/EmptyRouterView.vue'),
        children: [
          {
            name: 'BarcodeScanning',
            path: '',
            component: () => import('@/views/exports/barcode-scanning/BarcodeScanningView.vue'),
          },
        ],
      },
    ],
  },
];
